import { render, staticRenderFns } from "./Release.vue?vue&type=template&id=3c196438&scoped=true&"
import script from "./Release.vue?vue&type=script&lang=js&"
export * from "./Release.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c196438",
  null
  
)

export default component.exports